import {
  createContext,
  Context,
  useState,
} from 'react';
import { Progress } from 'view-layer/components/common';

export const GlobalContext: Context<any> = createContext({
  setProgress: () => {},
});

export const GlobalContextProvider = (props: any) => {
  const [loading, setLoading] = useState(false);

  const value = {
    setProgress: (val: boolean) => {
      setLoading(val);
    },
  };

  return (
    <GlobalContext.Provider value={value}>
      {props.children}
      <Progress show={loading} />
    </GlobalContext.Provider>
  );
};
